import React from 'react'

export default function Button({children, className, buttonType, ...props}) {
  return (
    <button className={`${buttonType === "default"? "" : "btn-theme"} ${className ?? ""}`} {...props}>{children}</button>
  )
}
